<template>
  <div>
       <v-navigation-drawer v-model="drawer" app temporary dark src="@/assets/text.jpg">
        <v-list class="mt-10">
          <v-list-item>
            <!--v-list-item-avatar>
              <img src="@/assets/img/logo.png" alt="Logo" />
            </v-list-item-avatar-->
            <v-list-item-content>
              <v-list-item-title class="title text-color">
                @unjosesantiago
              </v-list-item-title>
              <!--v-list-item-subtitle>WEB</v-list-item-subtitle-->
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider/>
        <v-list dense>
          <v-list-item v-for="([icon, text, link], i) in items" :key="i" link @click="$vuetify.goTo(link)">
            <v-list-item-icon class="justify-center">
              <v-icon color="#13491E">{{ icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="subtitile-1 text-color">{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
       </v-navigation-drawer>
      <v-app-bar app :color="color" :flat="flat" class="px-15 mt-0" :class="{ expand: flat }">
        <v-toolbar-title>
          <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="mr-4" v-if="isXs"/>
          
          <span :class="flat?'black--text':'white--text'">
            José Santiago
          </span>
          <!--v-avatar v-if="!isXs" tile size="150">
            <v-img :src="logo" contain/>
          </v-avatar-->
        </v-toolbar-title>
        <v-spacer/>

        <div v-if="!isXs"> 
          <v-btn class="mr-0" :color="flat?'#13491E':'white'" outlined text @click="$vuetify.goTo('#IndexComponent')">Inicio</v-btn>
          <v-btn class="mr-0" text :color="flat?'#13491E':'white'" @click="$vuetify.goTo('#about')">Sobre mí</v-btn>
          <v-btn class="mr-0" text :color="flat?'#13491E':'white'" @click="$vuetify.goTo('#catalog')">Portafolio</v-btn>
          <v-btn class="mr-0" text :color="flat?'#13491E':'white'" @click="$vuetify.goTo('#contact')">Contacto</v-btn>

        </div>
      </v-app-bar>
  </div>
</template>

<script>
import {mapState} from "vuex"
export default {
name: "NavbarComponent",
  props:{
    color:String,
    flat:Boolean
  },
  data:()=>({
    logo:require('../assets/img/logo.png'),
    isXs:false,
    drawer:null,
    items: [
      ["mdi-home-outline", "Inicio", "#IndexComponent"],
      ["mdi-human-greeting", "Sobre mí", "#about"],
      ["mdi-account-group", "Portafolio", "#catalog"],
      ["mdi-phone", "Contacto", "#contact"],
    ],
  }),
  computed:{
    ...mapState("user",["user"])
  },
  methods:{
    async doLogout(){
      try {
        await this.$store.dispatch("user/doLogout");
        this.$router.push({name:"auth"})
        this.$toast.success('Logged out')
      }catch (e) {
        this.$toast.error(e.message)
      }
    },
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },
   mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  watch:{
    isXs (value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  }
}
</script>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}
.text-color{
color:#13491E
}
</style>